import { Component } from '@angular/core';
import { FooterComponent } from '../../shared/footer/footer.component';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [FooterComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  constructor(private titleService: Title, private meta: Meta,) {

    const title = 'About Us - Softnet Computers - Negombo, Sri Lanka'
    const des = 'Upgrade your tech at Softnet Computers, Sri Lanka\'s top store in Negombo! Gaming laptops, business PCs, used desktops & more. Call Now: 077 (255) 3478. Trusted warranty & support'

    try {
      this.meta.removeTag('title');
      this.meta.removeTag('description');

      this.meta.removeTag('og:type');
      this.meta.removeTag('og:url');
      this.meta.removeTag('og:title');
      this.meta.removeTag('og:description');
      this.meta.removeTag('og:image');


      this.meta.removeTag('twitter:card');
      this.meta.removeTag('twitter:url');
      this.meta.removeTag('twitter:title');
      this.meta.removeTag('twitter:description');
      this.meta.removeTag('twitter:image');
      this.meta.removeTag('twitter:image');
    } catch (error) {

    }
    this.titleService.setTitle(title)
    this.meta.addTag({ name: 'title', content: title });

    this.meta.addTag({ name: 'description', content: des });

    this.meta.addTag({ property: 'og:type', content: 'website' });
    this.meta.addTag({ property: 'og:url', content: 'https://softnetcomputers.lk' + '/about-us' });
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ name: 'og:description', content: des });
    this.meta.addTag({ property: 'twitter:url', content: 'https://softnetcomputers.lk' + '/about-us' });
    this.meta.addTag({ property: 'twitter:title', content: title });
    this.meta.addTag({ name: 'twitter:description', content: des });

  }
}
